"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useTableQuery;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _lodash = require("lodash");
var _react = require("react");
var _useQueryParams = require("use-query-params");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var queryParamOptions = {
  updateType: 'replaceIn',
  includeAllParams: true,
  removeDefaultsFromUrl: true
};
function useTableQuery(queryParamPrefix, defaultState) {
  var defaultStateRef = (0, _react.useRef)(defaultState);
  var _useQueryParam = (0, _useQueryParams.useQueryParam)("".concat(queryParamPrefix, "_page_index"), (0, _useQueryParams.withDefault)(_useQueryParams.NumberParam, defaultStateRef.current.pagination.pageIndex), queryParamOptions),
    _useQueryParam2 = (0, _slicedToArray2["default"])(_useQueryParam, 2),
    pageIndex = _useQueryParam2[0],
    setPageIndex = _useQueryParam2[1];
  var _useQueryParam3 = (0, _useQueryParams.useQueryParam)("".concat(queryParamPrefix, "_page_size"), (0, _useQueryParams.withDefault)(_useQueryParams.NumberParam, defaultStateRef.current.pagination.pageSize), queryParamOptions),
    _useQueryParam4 = (0, _slicedToArray2["default"])(_useQueryParam3, 2),
    pageSize = _useQueryParam4[0],
    setPageSize = _useQueryParam4[1];
  var _useQueryParam5 = (0, _useQueryParams.useQueryParam)("".concat(queryParamPrefix, "_sort_id"), (0, _useQueryParams.withDefault)(_useQueryParams.StringParam, defaultStateRef.current.sorting.id), queryParamOptions),
    _useQueryParam6 = (0, _slicedToArray2["default"])(_useQueryParam5, 2),
    sortId = _useQueryParam6[0],
    setSortId = _useQueryParam6[1];
  var _useQueryParam7 = (0, _useQueryParams.useQueryParam)("".concat(queryParamPrefix, "_sort_desc"), (0, _useQueryParams.withDefault)(_useQueryParams.BooleanParam, defaultStateRef.current.sorting.desc), queryParamOptions),
    _useQueryParam8 = (0, _slicedToArray2["default"])(_useQueryParam7, 2),
    sortDesc = _useQueryParam8[0],
    setSortDesc = _useQueryParam8[1];
  var _useQueryParam9 = (0, _useQueryParams.useQueryParam)("".concat(queryParamPrefix, "_q"), (0, _useQueryParams.withDefault)(_useQueryParams.StringParam, defaultStateRef.current.search), queryParamOptions),
    _useQueryParam0 = (0, _slicedToArray2["default"])(_useQueryParam9, 2),
    search = _useQueryParam0[0],
    setSearch = _useQueryParam0[1];
  var _useQueryParam1 = (0, _useQueryParams.useQueryParam)("".concat(queryParamPrefix, "_filters"), (0, _useQueryParams.withDefault)(_useQueryParams.JsonParam, defaultStateRef.current.filters), queryParamOptions),
    _useQueryParam10 = (0, _slicedToArray2["default"])(_useQueryParam1, 2),
    filters = _useQueryParam10[0],
    setFilters = _useQueryParam10[1];
  var onPaginationChange = (0, _react.useCallback)(function (updater) {
    var newParams = updater({
      pageIndex: pageIndex,
      pageSize: pageSize
    });
    setPageIndex(newParams.pageIndex);
    setPageSize(newParams.pageSize);
  }, [pageIndex, pageSize, setPageIndex, setPageSize]);
  var onSortingChange = (0, _react.useCallback)(function (updater) {
    var newParams = updater({
      id: sortId,
      desc: sortDesc
    });
    setSortId(newParams.id);
    setSortDesc(newParams.desc);
  }, [sortId, sortDesc, setSortId, setSortDesc]);
  var setFilter = (0, _react.useCallback)(function (filterId, value) {
    setFilters(function (prevFilters) {
      return _objectSpread(_objectSpread({}, prevFilters), {}, (0, _defineProperty2["default"])({}, filterId, value));
    });
  }, [setFilters]);
  var toggleSingleFilter = (0, _react.useCallback)(function (filterId, value) {
    setFilters(function (prevFilters) {
      return _objectSpread(_objectSpread({}, prevFilters), {}, (0, _defineProperty2["default"])({}, filterId, prevFilters[filterId] === value ? undefined : value));
    });
  }, [setFilters]);
  var toggleMultiFilter = (0, _react.useCallback)(function (filterId, value) {
    setFilters(function (prevFilters) {
      return _objectSpread(_objectSpread({}, prevFilters), {}, (0, _defineProperty2["default"])({}, filterId, (0, _lodash.xor)(prevFilters[filterId], [value])));
    });
  }, [setFilters]);
  var toggleFilter = (0, _react.useCallback)(function (filterId, value) {
    if (Array.isArray(defaultStateRef.current.filters[filterId])) {
      toggleMultiFilter(filterId, value);
    } else {
      toggleSingleFilter(filterId, value);
    }
  }, [toggleMultiFilter, toggleSingleFilter]);
  var onMultiDropdownChange = (0, _react.useCallback)(function (filterId, value) {
    setFilters(function (prevFilters) {
      return _objectSpread(_objectSpread({}, prevFilters), {}, (0, _defineProperty2["default"])({}, filterId, value.map(function (v) {
        return v.value;
      })));
    });
  }, [setFilters]);
  var clearAllFilters = (0, _react.useCallback)(function () {
    setFilters(function () {
      return Object.entries(defaultStateRef.current.filters).reduce(function (acc, _ref) {
        var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        acc[key] = Array.isArray(value) ? [] : undefined;
        return acc;
      }, {});
    });
  }, [setFilters]);
  var state = (0, _react.useMemo)(function () {
    return {
      pagination: {
        pageIndex: pageIndex,
        pageSize: pageSize
      },
      sorting: {
        id: sortId,
        desc: sortDesc
      },
      search: search,
      filters: filters
    };
  }, [pageIndex, pageSize, sortId, sortDesc, search, filters]);
  var helpers = (0, _react.useMemo)(function () {
    return {
      onPaginationChange: onPaginationChange,
      onSortingChange: onSortingChange,
      setSearch: setSearch,
      toggleFilter: toggleFilter,
      setFilter: setFilter,
      onMultiDropdownChange: onMultiDropdownChange,
      setFilters: setFilters,
      clearAllFilters: clearAllFilters
    };
  }, [onPaginationChange, onSortingChange, setSearch, toggleFilter, setFilter, onMultiDropdownChange, setFilters, clearAllFilters]);
  return [state, helpers];
}
//# sourceMappingURL=useTableQuery.js.map